"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateEventConditionDialog = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const Workflow_context_1 = require("../Workflow.context");
const StyledDialog = (0, styled_components_1.default)(core_1.Dialog) `
  .delete {
    color: ${props => props.theme.palette.error.main};
  }
`;
const StateEventConditionDialog = props => {
    const { open, event, taskTypeId, condition: initialCondition, onCancel, onChange, onDelete } = props;
    const { transitionConditionPlugins } = (0, Workflow_context_1.useWorkflowContext)();
    const [openConfirmDelete, setOpenConfirmDelete] = (0, react_1.useState)(false);
    const [condition, setCondition] = (0, react_1.useState)(initialCondition || { type: '', params: {} });
    if (!condition.params) {
        condition.params = {};
    }
    const plugin = transitionConditionPlugins.find(p => p.type === condition.type);
    return (react_1.default.createElement(StyledDialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, "Transition Condition"),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, label: 'Conditions', variant: 'outlined', value: condition.type, onChange: event => {
                    condition.type = event.target.value;
                    setCondition(Object.assign({}, condition));
                } }, transitionConditionPlugins
                .filter(plugin => !plugin.canConfigure || plugin.canConfigure(event))
                .map(plugin => (react_1.default.createElement(core_1.MenuItem, { key: plugin.type, value: plugin.type }, plugin.label)))),
            plugin ? (react_1.default.createElement("div", { className: 'transition-condition' },
                react_1.default.createElement(plugin.configurator, { event: event, condition: condition, taskTypeId: taskTypeId, onChange: condition => setCondition(condition) }))) : (condition.type && (react_1.default.createElement(lab_1.Alert, { severity: 'error' },
                "Transition condition \"",
                condition.type,
                "\" plugin not found.")))),
        react_1.default.createElement(core_1.DialogActions, null,
            initialCondition && (react_1.default.createElement(core_1.Box, { flex: 1 },
                react_1.default.createElement(core_1.Button, { className: 'delete', onClick: () => setOpenConfirmDelete(true) }, "Delete"))),
            react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', onClick: () => onChange === null || onChange === void 0 ? void 0 : onChange(condition) }, "Save")),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: openConfirmDelete, title: 'Delete Transition Condition', message: 'Are you sure you want to delete this transition condition?', onCancel: () => setOpenConfirmDelete(false), onConfirm: () => {
                setOpenConfirmDelete(false);
                onDelete === null || onDelete === void 0 ? void 0 : onDelete(condition);
            } })));
};
exports.StateEventConditionDialog = StateEventConditionDialog;
exports.default = exports.StateEventConditionDialog;
//# sourceMappingURL=StateEventConditionDialog.js.map